var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-asmt-item-validation"},[_c('span',{staticClass:"ibx-asmt-item-card-item-notice__label"},[_c('font-awesome-icon',{staticClass:"ibx-asmt-item-validation__icon",attrs:{"icon":['fas', 'info-circle']}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.validationErrorMessage)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }